module.exports = __webpack_public_path__ + "img/covidcover_mul.50042ef9.webp";